import React, {ComponentType} from 'react';
import {Header} from "./layout/Header";
import {Route, Routes} from "react-router-dom";
import {Body} from "./layout/Body";
import Box from "@mui/material/Box";
import {withAuthenticationRequired} from "react-oidc-context";
import {Home} from "./Home";
import {CompaniesPage} from "./pages/CompaniesPage";
import {CompanyPage} from "./pages/CompanyPage";
import {TokenRequestPage} from "./pages/TokenRequestPage";
import {MyCompaniesPage} from "./pages/MyCompaniesPage";
import {MyCompanyPage} from "./pages/MyCompanyPage";

interface AuthGuardProps {
    component: ComponentType<object>;
}

const AuthGuard = ({component}: AuthGuardProps) => {
    const Component = withAuthenticationRequired(component, {
        OnRedirecting: () => (<>Redirecting...</>),
        signinRedirectArgs: {redirect_uri: window.location.href}
    })
    return <Component/>
}
const AppRoutes = () =>
    <Routes>
        <Route path="" element={<Home/>}/>
        <Route path="/companies" element={<AuthGuard component={CompaniesPage}/>}/>
        <Route path="/companies/:companyId" element={<AuthGuard component={CompanyPage}/>}/>
        <Route path="/companies/:companyId/token_requests/:tokenRequestId"
               element={<AuthGuard component={TokenRequestPage}/>}/>
        <Route path="/my-companies" element={<AuthGuard component={MyCompaniesPage}/>}/>
        <Route path="/my-companies/:companyId" element={<AuthGuard component={MyCompanyPage}/>}/>
    </Routes>

function App() {
    return (
        <>
            <Box sx={{width: {xs: '100vw', xl: '60vw'}, marginLeft: {xs: '0', xl: '20vw'}}}>
                <Header/>
                <Body>
                    <AppRoutes></AppRoutes>
                </Body>
            </Box>
        </>
    );
}

export default App;
